import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Logo } from "../components/Logo";
import { api, formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("arkaari_token", data.token);
      localStorage.setItem("arkaari_admin", JSON.stringify(data.user));
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#121212] text-[#F5F2EA] grain relative flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <Logo color="#D9BE86" size="text-2xl" />
          <p className="overline text-white/40 mt-6">Atelier Dashboard</p>
        </div>
        <form data-testid="admin-login-form" onSubmit={submit} className="space-y-7 bg-white/[0.03] border border-white/10 p-8 rounded-sm">
          <label className="block">
            <span className="overline text-white/40 block mb-2">Email</span>
            <input data-testid="admin-email" type="email" className="field !border-white/20 !text-[#F5F2EA]" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="ankita@arkaari.com" />
          </label>
          <label className="block">
            <span className="overline text-white/40 block mb-2">Password</span>
            <input data-testid="admin-password" type="password" className="field !border-white/20 !text-[#F5F2EA]" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </label>
          {error && <p data-testid="admin-error" className="text-[#e0a0a0] text-sm">{error}</p>}
          <button data-testid="admin-login-btn" disabled={loading} className="btn-gold w-full py-4 overline disabled:opacity-60">
            <span className="inline-flex items-center gap-2 justify-center">{loading && <Loader2 size={16} className="animate-spin" />}Sign in</span>
          </button>
        </form>
      </div>
    </div>
  );
}
